module.exports = {
  pleaseWait: 'ခဏစောင့်ပါ',
  loading: 'လုပ်ဆောင်နေသည်',
  Billing: 'မှတ်တမ်း',
  billingTips: 'ဝယ်ယူခြင်း နှင့် အသုံးပြုမှုမှတ်တမ်း',
  ID: 'ကုတ်နံပါတ်',
  FAQ: 'သိလိုရာများ',
  TC: 'စည်းမျဥ်းများ',
  Copyright: '© 2024 All Rights Reserved.',
  GenerateImage: 'ပုံထုတ်ပါ',
  generateTips1: 'ကျွန်ုပ်တို့၏ AI ရုပ်ပုံထုတ်ပေးသည့်စက်သည် စိတ်ကူးစိတ်သန်းများကို အသက်ဝင်စေကာ ရင်သပ်ရှုမောဖွယ်အနုပညာ၊ သရုပ်ဖော်ပုံများနှင့် ဓာတ်ပုံများကို စက္ကန့်ပိုင်းအတွင်း ထုတ်လုပ်ပေးပါသည်။ တီထွင်ဖန်တီးနိုင်စွမ်းကို ထုတ်ဖော်ပြီး AI ၏ နည်းလမ်းသစ်များဖြင့် သင့်ရုပ်ပုံအသစ်အဆန်းများကို ဖန်တီးပါ။ တစ်မူထူးခြားသော စျေးကွက်ရှာဖွေရေးပစ္စည်းများကို ဖန်တီးခြင်းမှ လှပသောအနုပညာလက်ရာများဖန်တီးခြင်းအထိ အဆုံးမရှိဖြစ်နိုင်ချေများကို စူးစမ်းလေ့လာပါ။·',
  generateTips2: 'အောက်က စကားလုံးတချို့ ကို ရိုက်ထည့်ပြီး Snapai က စာသားကို မယုံနိုင်လောက်အောင် အနုပညာအဖြစ် ပြောင်းလဲတာကို ကြည့်လိုက်ပါ',
  Prompt: 'လျင်မြန်သော',
  PromptTips1: 'ဘာဆွဲရမလည်း AI ကိုပြောပါ',
  PromptTips2: 'ခံစားချက်နဲ့အလင်းရောင်ကိုဖော်ပြပါ။နောက်ထက်စာမျက်နှာအတွက်အကြံပြုချက်ကိုကြည့်ပါ',
  PromptTips3: 'AI လမ်းညွှန်မှုကိုမလိုက်နာ၍ရေတွက်မရပါ',
  Generate: 'ပုံထုတ်ပါ',
  ChancesLeft: 'လက်ကျန်အကြိမ်ရေ',
  BuyChances: ' အကြိမ်ရေထပ်မံဝယ်ယူရန် ',
  generateImageTips1: 'ပုံ၏ဖော်ပြချက်ရိုက်ထည့်ပါ',
  generatePromptsTips1: 'သင်မလိုချင်သည့်အရာများကိုရေးပါ',
  indexTips1: 'နေ့စဥ်အခမဲ့အကြိမ်ရေ <br /> ရရှိပါသည်။',
  indexTips2: 'တစ်ခုကိုရွေးပါ',
  ImageRestorer: 'ရုပ်ပုံသိမ်းဆည်းခြင်း',
  Continue: 'ဆက်သွားပါ',
  language0: 'ဘာသာစကား',
  language: 'ဘာသာစကားရွေးချယ်ပါ',
  languageTips: 'ဒီနေရာတွင်ဘာသာစကားရွေးချယ်ပါ',
  Submit: 'တင်သွင်းပါ',
  change: 'ပြောင်းလဲရန် ',
  English: 'အင်္ဂလိပ်',
  Myanmar: 'မြန်မာဘာသာ',
  Login: 'ဝင်ရန်',
  Logout: 'အကောင့်မှထွက်ရန်',
  getCode: 'Resend',
  loginTips: 'ဖုန်းနံပါတ်ဖြည့်ပါ',
  profile: 'မိမိအကောင့်',
  phoneNumber: 'ဖုန်းနံပါတ်',
  SubscribedSince: 'စာရင်းသွင်းသည့်နေ့ ',
  RemainingChances: 'ကျန်ရှိနေသောအခွင့်အလမ်းများ',
  cgtips2: 'နေ့စဥ် ၁၄၉ကျပ်​/စာရင်းသွင်းရန် OK ကိုနှိပ်ပါ။',
  cgtips2W: 'အပတ်စဥ် ၅၉၉ကျပ်​/စာရင်းသွင်းရန် OK ကိုနှိပ်ပါ။',
  cgtips2M: 'လစဥ် ၁၉၉၉ကျပ်​/စာရင်းသွင်းရန် OK ကိုနှိပ်ပါ။',
  OK: 'OK',
  Upload: 'တင်သည်။',
  PictureRestorer: 'ပုံသိမ်းဆည်းခြင်း',
  PictureTips1: 'AI ဖြင့် ပုံများကိုအရောင်အသွေးလှပစွာဖြင့်နဂိုအတိုင်းပြန်လည်ပြုပြင်ပါ။ Snapai သည် ခြစ်ရာများကို ဖယ်ရှားရန်၊ အရောင်များကို ပေါ်လွင်လာစေရန်နှင့် မျက်နှာများကို ​​​ကြည်လင်လာစေရန်၊ ပျက်စီးနေသော ဓာတ်ပုံများကို မြတ်နိုးဖွယ် အမှတ်တရများအဖြစ်သို ပြောင်းလဲရန်အတွက် နောက်ဆုံးပေါ် သုတေသနကို တည်ဆောက်ပါသည်။ ကျွန်ုပ်တို၏ ဝန်ဆောင်မှုသည် အရောင်ဓာတ်ပုံများနှင့် အဖြူအမည်းများကို အခမဲ့ပြုပြင်ပေးပါသည်',
  PictureTips2: 'ခြစ်ရာတွေရှိပါသလား',
  Restore: 'သိမ်းဆည်းထားမည်',
  uploadTips: 'ကျေးဇူးပြု၍ပုံတင်သွင်းပါ',
  PurchaseChances: 'Chance ဝယ်ယူမည်',
  History: 'ပုံမှတ်တမ်း',
  purchaseTips1: 'စုစုပေါင်းအခွင့်အရေး',
  purchaseTips2: 'အကြိမ်ရေထပ်မံဝယ်ယူမည်',
  Daily: 'နေ့စဥ်',
  Weekly: 'အပတ်စဥ်',
  OneTime: 'တစ်ကြိမ်',
  Purchase: 'ဝယ်ယူမည်',
  DailyKyats: '169 Kyats',
  WeeklyKyats: '699 Kyats',
  OneTimeChance: '149 Ks/Chance',
  Subscribe: 'စာရင်းသွင်းပါ',
  purchaseTips3: 'အကြိမ်ရေဝယ်ယူရန်  <strong>ကြိမ်</strong>ဝယ်ယူမည်',
  BuyNow: 'ဝယ်ယူမည်',
  logOut: 'လော့ဂ်အောက်ထွက်သည်',
  petTitle1: 'တိရစ္ဆာန် ကာတွန်းပုံ',
  petTitle2: 'စတိုင် ရွေးချယ်ပါ။',
  petContent1: ' သင့်အိမ်မွေးတိရစ္ဆာန်လေးတွေရဲ့ဓာတ်ပုံကိုဆန်းသစ်တဲ့ကာတွန်းလက်ရာပုံလေးတွေအဖြစ်ပြောင်းလိုက်ပါ။အိမ်မွေးတိရစ္ဆာန်ချစ်သူလေးတွေနဲ့ကာတွန်းဝါသနာရှင်တွေရဲ့အမွှေးထူသူငယ်ချင်းလေးတွေအတွက် ပျော်ရွှင်စရာတွေနဲ့ ဂုဏ်ပြုပေးဖို့အကောင်းဆုံးပါပဲ။',
  sexTitle1: 'လူကာတွန်းပုံ',
  sexTitle2: 'ကျား/မ ရွေးချယ်ပါ။',
  sexContent1: 'အချက်အလက်လေးတွေရေးထည့်ပြီးသင့်ရဲ့စိတ်ကူးထဲက ကာတွန်းပုံလေးတွေကိုပုံဖော်ကြမယ်။ သင်က ကာတွန်းဝါသနာရှင်၊ ပုံပြင်တွေကြိုက်တဲ့သူ ဒါမှမဟုတ်ဒီဇိုင်နာတစ်ယောက်ဆိုရင် ဒီပုံပြုလုပ်တာလေးက အရည်အသွေးကောင်းပြီး တောက်ပတဲ့ ကာတွန်းပုံလေးတွေကို အဆင့်မြင့် AI ကမတူညီတဲ့အမြင်တွေနဲ့ ဖန်တီးပေးမှာပါ။',
  sexContent2: 'အောက်တွင်ကျား၊မ ရွေးချယ်ပြီးမိမိပုံကိုတင်ပါ။အံ့သြစရာပုံလေးတွေထွက်လာပါလိမ့်မယ်။',
  Female: 'မ',
  Male: 'ကျား',
  Style1: 'စတိုင် 1',
  Style2: 'စတိုင် 2',
  Style3: 'စတိုင် 3',
  Comic: 'ရုပ်ပြ',
  Disney: 'ဒစ်စနေး',
  Ghibli: 'ဂစ်ဘလီ',
  Animalanime: 'Selfie Anime',
  HumanAnime: 'လူ',
  Guidance: 'လမ်းညွှန်ချက်',
  PetAnime: 'Pet Anime',
  landTips1: 'ရင်သပ်ရှုမောဖွယ် ဓာတ်ပုံများကို ဖန်တီးပြီး',
  landTips2: 'ဆုကြီးများကို ရယူလိုက်ပါ',
  landTips3: 'သင့်ရဲ့စိတ်ကူးတွေကို SnapAI နဲ့ လက်တွေ့ပြောင်းလဲလိုက်ပါ။ အံ့မခန်းပုံတွေဖန်တီးမှုများမှစ၍ အနုပညာလက်ရာများအထိ အရင်ကမတွေ့ဖူးသေးတာတွေကိုSnapAI ကသင့်ကို ဖန်တီးပေးပါလိမ့်မယ်။ အခုပဲအကန့်အသတ်မရှိတဲ့ ဖန်တီးမှုတွေကို စတင်လိုက်ပါ။',
  show401tip: 'လက်ကျန် မလုံလောက်ပါ။',
  show400dailytip: 'အချိန်ကုန်သွားပြီ၊ ကျေးဇူးပြု၍ 548 သို "ON1" ပေးပို၍ ဆုကြီးကြီးရယူပါ။',
  show400weeklytip: 'အချိန်ကုန်သွားပြီ၊ ကျေးဇူးပြု၍ 548 သို "ON7" ပေးပို၍ ဆုကြီးကြီးရယူပါ။',
  register: 'စာရင်းသွင်းပါ။',
  invitation: 'ဖိတ်ခေါ်ခြင်း',
  invitationTips: 'အောက်ပါဖိတ်ခေါ်ချက်လင့်ခ်ကို ကူးယူပြီး သူငယ်ချင်းထံပေးပို့ပါ',
  InviteNow: 'အခုပဲ ဖိတ်ခေါ်မယ်',
  copySuccess: 'ကူးယူမှု အောင်မြင်ပါသည်',
  process: 'ပုံထုတ်နေသည်',
  downTips1: 'ကျေးဇူးပြု၍ လင့်ခ်ကို browser ထဲသို့ ကူးယူပြီး ဒေါင်းလုဒ်လုပ်ပါ။',
  copyLink: 'လင့်ခ်ကိုကူးယူပါ။',
  free: 'အခမဲ့',
  aiAnimeTitle: 'စုံတွဲကာတွန်းပုံံ',
  aiAnimeCt1: 'သင်၏မူရင်းစုံတွဲဓာတ်ပုံများကို Anime ပုံစံဓာတ်ပုံများအဖြစ် ပြောင်းလဲပြီး သင့်ရဲ့ ရင်ခုန်စရာအမှတ်တရများကို ပိုမိုလှပအောင်ဖန်တီးလိုက်ပါ။ သင်သည် Anime ကိုကြိုက်နှစ်သက်သူ (သို့မဟုတ်) ဒီဇိုင်နာတစ်ယောက်ဖြစ်ပါက AI Anime Photo သည် သင့်အား အဓိပ္ပါယ်ရှိသော အရည်အသွေးမြင့် Anime ပုံစံရုပ်ပုံများကို အားစိုက်ထုတ်စရာမလိုဘဲ ဖန်တီးနိုင်မည်ဖြစ်ပြီး၊ အဆင့်မြင့် AI နည်းပညာဖြင့် သင့်အချစ်ရေးကို ပြီးပြည့်စုံစွာ ပေါင်းစပ်ဖန်တီးလိုက်ပါ။',
  aiAnimeCt2: 'SnapAI မှာအောက်ပါ စတိုင်လ်ကို ရွေးချယ်ပြီး သင့်ရဲ့ ချိုမြိန်သော အမှတ်တရများကို ရင်သပ်ရှုမောဖွယ် အနုပညာလက်ရာများအဖြစ် ပြောင်းလဲလိုက်ပါ။',
  comingsoonT: 'မကြာမီ',
  SubscribePackage: 'စာရင်းသွင်းခြင်း',
  landfont1: 'ကိုယ့်ဓာတ်ပုံလေးတွေကို အမိုက်စား ကာတွန်းပုံလေးတွေ ပြောင်းကြမယ်',
  landfont2: 'ကိုယ့်ရဲ့စုံတွဲပုံလေးတွေကို ကာတွန်းပုံလှလှလေးတွေအဖြစ် ပြောင်းကြမယ်',
  landfont3: 'စိတ်ကူးထဲကပုံလေးတွေကို စာရေးပြီး ပုံထုတ်ကြည့်ကြမယ်',
  landfont4: 'သင့်ရဲ့အိမ်မွေးတိရစ္ဆာန်လေးတွေကို ချစ်စရာ ကာတွန်းပုံလေးတွေပြောင်းကြမယ်',
  landfont5: 'ဟိုးအရင်က အမှတ်တရလေးတွေကို AI နဲ့ပြန်ပြီး အသက်သွင်းကြမယ်',
  SmartCutout: 'နောက်ခံပုံဖျက်မယ်',
  letgo: 'သွားမယ်',
  IpIMage: 'လိုင်စင်ပုံ',
  IpIMageTip: 'လိုင်စင်ဓာတ်ပုံကို လွယ်ကူလျင်မြန်စွာ ထုတ်ကြမယ်။',
  IpIMage_content: 'လိုင်စင်ဓာတ်ပုံအဖြစ် ပြောင်းလဲလိုသော မူရင်းပုံသည် ကြည်လင်ပြတ်သားပြီး မျက်နှာသည် ရှေ့တည့်တည့်အနေအထားဖြစ်ရမည်။ ပခုံးများသည် \n' +
    'လိုင်စင်ပုံများအတိုင်းတပြေးညီအနေအထားဖြစ်ရမည်။ မဟုတ်ပါက ပြောင်းလဲ၍မရနိုင်ပါ။',
  snapbot: 'SnapBot',
  snapbot_hi: 'မင်္ဂလာပါ၊ ကျွန်တော် SnapBot ဖြစ်ပါတယ်။',
  help_today: 'ဒီနေ့မှာ ဘာတွေကူညီပေးရမလဲ?',
  think_ip: '🤖 စဉ်းစားနေပါပြီ...',
  Coloring_old_photos: 'ပုံအရောင်သွင်း',
  Coloring_old_photos_tips: 'သင့်ရဲ့ငယ်ဘဝ အမှတ်တရ ပုံလေးတွေကို အရောင်ပြန်သွင်းလိုက်ပါ။\n' +
    'ဒီ SnapAI tool လေးနဲ့ဆိုရင် သဘာဝအတိုင်း အရောင်လေး‌တွေကို\n' +
    'ထိန်းညှိပေးပြီး မိမိရဲ့ မူရင်းပုံလေးတွေကို မထိခိုက်စေဘဲ ပုံလေးကိုလည်း\n' +
    'ပိုမိုလှပနေစေပါလိမ့်မယ်။',
  Coloring_old_photos_tips2: 'AI အစွမ်းနဲ့ ပုံအဟောင်းတွေ အရောင်ပြန်သွင်းမယ်',
  BgFusion: 'နောက်ခံပုံထည့်',
  BgFusion_tips2: 'သင့်ပုံလေးတွေကို စိတ်ကြိုက် နောက်ခံပုံလေးနဲ့ ပြုပြင်မယ်',
  BgFusion_tips: 'သင့်ရဲ့ပုံလေးတွေကို ကိုယ့်စိတ်ကြိုက် နောက်ခံပုံလေးနဲ့ ပြုပြင်ကြမယ်။\n' +
    'SnapAI က သင်တို့ရဲ့ မူရင်းပုံလေးတွေကို\n' +
    'နောက်ခံအသစ်နဲ့ သဘာဝကျကျ ပေါင်းစပ်ပေးပါလိမ့်မယ်။',
  Upload_bg: 'နောက်ခံပုံတင်ပါ',
  Upload_pt: 'ပုံတင်ပါ',
  Recolor: 'ပြောင်းလဲမည်',
  snapbotTips1: 'မြန်ဆန်သော ရှာဖွေမှုရလဒ်',
  snapbotTips2: 'နားလည်နိုင်စွမ်းနှင့် ဖြေရှင်းနိုင်စွမ်း',
  snapbotTips3: 'ဒေတာအများအပြား စီစစ်နိုင်ခြင်း',
  snapbotTips4: 'ဉာဏ်ရည်တု အယ်လဂိုရီသမ်',
  snapbotInput1: 'SnapBot နဲ့ စတင် စကားပြောမယ်',
  white: 'အဖြူ',
  blue: 'အပြာ',
  '1 inch': '1 လက်မ',
  '2 inches': '2 လက်မ',
  '3 inches': '3 လက်မ',
  landTips11: 'ရင်သပ်ရှုမောဖွယ် ဓာတ်ပုံများကို ဖန်တီးရင်း',
  ChangeHairstyle: 'ဆံပင်ပုံစံပြောင်းမယ်',
  ChangeHairstyle_short: 'သင့်စိတ်ကူးထဲက ဆံပင်ပုံစံများကို ပြောင်းကြမယ်',
  ChangeHairstyle_content_1: 'ကျွန်ုပ်တို့၏ စစ်စတမ်တွင် ဆံပင်ပုံစံများစွာကိုလည်း ပြောင်းလဲလို့ရနိုင်ပါသည်။ အသုံးပြုသူ၏ မျက်နှာသွင်ပြင် အနေအထား နှင့် ကြိုက်နှစ်သက်ရာ ဆံပင်ပုံစံကိုရွေးချယ်ပြီး AI နည်းပညာက စမ်းသစ်စွာ ဖန်တီးပေးခြင်းကို စမ်းကြည့်နိုင်ပါသည်။ မတူညီသောဆံပင်ပုံစံများကို လွယ်ကူစွာ ပြောင်းလဲ ရှာဖွေစမ်းသပ်ခြင်းဖြင့် စိတ်ပျော်ရွှင်မှုများကို ရယူနိုင်ပါသည်။',
  ChangeHairstyle_content_2: 'အောက်တွင်ပါရှိသော ဆံပင်ပုံများမှကြိုက်နှစ်သက်ရာ ဆံပင်စတိုင်ကိုရွေးချယ်ပြီး မိမိပုံကိုထည့်သွင်းပါ။ လှပေသာ ဆံပင်စတိုင်နှင့်ပုံလေးကို ရရှိမှာပါ။',
  Result: 'ရလဒ်',
  Original: 'မူရင်း',
  unsub_tip: 'ဝန်ဆောင်မှုကို ပယ်ဖျက်ရန် OFF ဟု ရိုက်ပြီး 548 သို့ပို့ပါ။',
  sub_tip: "ဝန်ဆောင်မှုကိုရယူရန် 'ON1' သို့မဟုတ် 'ON7' ဟု ရိုက်ပြီး 548 သို့ ပို့ပါ။",
  longHairEffects: 'ဆံပင်ရှည်ဖန်တီးမယ်',
  longHairEffects_tip: 'Long Hair Effect ကို စမ်းကြည့်လိုက်ပါ သဘာဝဆန်ပြီး ဆွဲဆောင်မှုရှိတဲ့ ဆံပင်ပုံစံကိုစမ်းကြည့်လိုက်ပါတယ်။ ဒီ Effect လေးက သင့်ရဲ့ဆံပင်တွေကိုရှည်သွားသလိုဖန်တီးပေးမှာဖြစ်ပါတယ်။ \n' +
    'ချောမွေ့ပြီး တောက်ပတယ်\n' +
    'သဘာဝဆန်တဲ့ ဆံပင်ရှည်ပုံစံ\n' +
    'မည်သည့် ဖက်ရှင်နှင့်မဆိုလိုက်ဖတ်ပါတယ် Long Hair Effect နဲ့ နေ့တိုင်းမှာ အကောင်းဆုံးလှပမှုကို ခံစားလိုက်ပါ!',
  VIDEO: 'ဗီဒီယို',
  image_video: 'ပုံကိုဗီဒီယိုအဖြစ်ဖန်တီးမယ်',
  image_video_tip: 'ဒီ Function သည် ဓာတ်ပုံကို အသက်ဝင်ပြီ ၁–၃ မိနစ်ကြာသောဗီဒီယိုအဖြစ် ပြောင်းလဲပေးပြီး သဘာဝမျက်နှာများနှင့် အရွေ့အပြောင်းများ ထည့်သွင်းကာ ဓာတ်ပုံကို အသက်ရှိသလို မြင်သာစေပါသည်။ အသုံးပြုသူများသည် အရင်ဖန်တီးထားသော ဗွီဒီယိုများကို ပုံမှတ်တမ်းမှစစ်ဆေးနိုင်ပါသည်။',
  word_video: 'စာသားကိုဗီဒီယိုဖန်တီးမယ်',
  word_video_tip: 'ယခု Function သည် မိမိတို့ ကြိုက်နှစ်သက်ရာ သွင်ပြင်ဟန်ပန်ပေါ်လွင်ရန် ရေးသားထားသောစာသားများကို  AI နည်းပညာဖြင့် ‌ရွေ့လျား အသက်ဝင်နေသော ဗီဒီယိုအဖြစ်ပြောင်းလဲဖန်တီးပေးပါသည်။ ဗီဒီယိုရရှိရန် ၁-၃ မိနစ်အတွင်းကြာနိုင်ပြီး ဖန်တီးထားခဲ့သော ဗီဒီယိုများကို ပုံမှတ်တမ်းတွင် စစ်ဆေးနိုင်ပါသည်။',
  word_video_input: "သင်ဖန်တီးချင်သောဗီဒီယို၏ ပုံပန်းသွင်ပြင်အမူအရာကို ရေးသားပါ",
  image_video_input: "သင်ဖန်တီးချင်သောဓာတ်ပုံ၏ သွင်ပြင်အမူအရာကို ရေးသားပါ",
  aiDressUp: "၀တ်စုံပြောင်း",
  aiDressUp_tip: "သင့်ရဲ့ ပုံစံလေးကို AI Dress Up နဲ့ ချက်ချင်းပြောင်းလဲလိုက်ပါ။ သင့်ရဲ့ဓာတ်ပုံလေးကို တင်လိုက်ပြီး ရိုးရာ၀တ်စုံ၊ သမာရိုးကျ၀တ်စုံ၊ ခေတ်စားနေတဲ့၀တ်စုံ စတဲ့၀တ်စုံလေးတွေကို စမ်း၀တ်ကြည့်လိုက်ပါ။ SnapAI က အဝတ်အစားတွေကို သင့်ခန္ဓာကိုယ်နဲ့ သဘာဝကျစွာချိန်ညှိပေးလို့ အမျိုးမျိုးသော ဖက်ရှင်အသစ်တွေကို ပျော်ပျော်ကြီး စမ်းကြည့်လို့ ရပါပြီနော်။",
  singleheart: "အသည်းပုံ",
  singleheart_desc: "သင့်ရဲ့ဗီဒီယိုထဲမှာ ချစ်စရာကောင်းပြီး ရိုမန်တစ်ဆန်တဲ့ နှလုံးသားပုံစံဖန်တီးပြီး သင်ချစ်ရတဲ့သူတွေကို သင်ဂရုစိုက်ကြောင်း ဖော်ပြလိုက်ပါ။",
  aiVividScene: "ပုံရိပ်သစ်များဖန်တီးခြင်း",
  aiVividScene_desc: "သင့်ကို အချိန်နဲ့ နေရာမျိုးစုံကို ပို့ပေးပြီး စိတ်ကြိုက်ပုံလှလှလေးတွေကို ဖန်တီးနိုင်ပါပြီ။ သင့်ရဲ့ ကြည်လင်ပြတ်သားတဲ့ မျက်နှာပုံလေးတစ်ပုံရှိရုံနဲ့ လိုချင်တဲ့ နောက်ခံမြင်ကွင်း၊ ပုံစံနဲ့ အရောင်အသွေးများကို ရွေးချယ်ပြီး စိတ်ကူးယဉ်ဆန်တဲ့ ဓာတ်ပုံအသစ်လေးတွေကို အလွယ်တကူ ဖန်တီးနိုင်ပါပြီ။ မိုးတွင်း၊ နွေရာသီ၊ ညဘက်၊ ကမ်းခြေ၊ မြို့ပြ စတဲ့ မတူညီတဲ့ မြင်ကွင်းမျိုးစုံမှာ ဓာတ်ပုံရိုက်ထားသလိုဖြစ်အောင် ဖန်တီးပေးမှာပဲ ဖြစ်ပါတယ်",
  pic_size_limit: "ဓာတ်ပုံများသည် ၅ မီဂါဘိုက်ထက် မကျော်လွန်ရပါ။",
  spin_tip_1: "သင့်အခွင့်အရေးကို လက်လွတ်မခံပါနဲ့!",
  spin_tip_2: "The spin wheel only provide in daily quest campaign",
  close: "close",
  spin: 'လှည့်ခြင်း',
  SpinChances: 'လှည့်ခွင့်များ',
  date: 'နေ့စွဲ',
  Prizes: 'ဆုများ',
  nochance: 'သင့်မှာအခွင့်အရေး မလုံလောက်ပါ',
  WinnerList: 'ကံထူးသူစာရင်း',
  Congratulations: "ဂုဏ်ယူပါတယ်၊ သင်အနိုင်ရခဲ့သည်",
  Confirm: "အတည်ပြုသည်",
  spinTips2: 'နေ့စဥ် အခမဲ့လှည့်ခွင့်',
  spinTips3: 'အခမဲ့လှည့်ခွင့်တိုကင်ကိုရယူပြီး ဒီနေ့ သင့်ရဲ့ကံကိုစမ်းကြည့်ပါ',
  spinTips4: 'တိုကင်ရယူပါ',
  No: 'နိုး',
  not_win: "ကျေးဇူးတင်ပါသည် နောက်တစ်ကြိမ်ကံကောင်းပါစေ",
  win_tip: 'သင့်ရဲ့ဆုများကိုရယူဖို့ အောက်ပါခလုပ်ကိုနှိပ်ပါ။',
  Trending: 'ခေတ်စားနေသော',
  Face_Magic: 'အံ့ဖွယ်မျက်နှာ',
  AI_Studio: 'AI စတူဒီယို',
  Home: 'ပင်မစာမျက်နှာ',
  unsubscribe: 'စာရင်းသွင်းမှု ရပ်ဆိုင်းရန်',
  Back: 'နောက်သို့',
  Chances: 'အခွင့်အရေးများ',
  Setting: 'ဆက်တင်',
  Menu: 'မီနူး',
  New: 'အသစ်',
  image_max_size: "ဖိုင်အရွယ်အစား 5MB ထက်ကျော်နေသည်",
  file_max_size: "ဖိုင်အရွယ်အစား 1MB ထက်ကျော်နေသည်",
  new_chat: "စကားပြောခန်းအသစ်",
  file: "ဖိုင်",
  image: "ပုံ",
  invalid_image_format: "မမှန်ကန်သော ဖိုင်ဖော်မတ်",
  Shoot_same_video: "ဗီဒီယိုရိုက်ကူးပါ",
  categories: 'အမျိုးအစားများ',
  ai_doc: 'AI စာရွက်စာတမ်း',
  ai_ppt_title: 'AI ပရက်စင်တေးရှင်း',
  ai_ppt_tip: 'စကားလုံးအနည်းငယ်ဖြင့် ပရိသတ်တိုင်းကို စိတ်ကျေနပ်စေမည့် မြန်ဆန်ပြီး ထိရောက်သော ပရက်စင်တေးရှင်းကို ဖန်တီးပါ။',
  ai_ppt_tips: 'စိတ်ကူးများကို စက္ကန့်ပိုင်းအတွင်း ရင်သပ်ရှုမောဖွယ် မြင်ကွင်းများအဖြစ် ပြောင်းလဲပါ။ AI ဖြင့် အရည်အသွေးမြင့် ရုပ်ပုံများ၊ အနုပညာလက်ရာများနှင့် ဒီဇိုင်းများကို အလွယ်တကူ ဖန်တီးပါ။ ဆိုရှယ်မီဒီယာ အကြောင်းအရာများမှ ထူးခြားသော ဖန်တီးမှု ပရောဂျက်များအထိ — စကားလုံးအနည်းငယ်ဖြင့် သင့်စိတ်ကူးများကို အသက်သွင်းလိုက်ပါ။',
  ai_resume_title: 'AI ကိုယ်ရေးရာဇဝင် ဖောင်',
  ai_resume_tip: 'စက္ကန့်ပိုင်းအတွင်း ပရော်ဖက်ရှင်နယ် AI ကိုယ်ရေးရာဇဝင်ကို ဖန်တီးပြီး သင့်အိမ်မက်အလုပ်ကို ရယူလိုက်ပါ။',
  author_tip: 'ကျေးဇူးပြု၍ ရေးသားသူအမည်ကို ထည့်သွင်းပါ။',
  Template: 'နမူနာပုံစံ',
  TemplateColor: 'နမူနာအရောင်',
  Background: 'နောက်ခံ',
  UploadAvatar: 'ကိုယ်ပိုင်ပုံတင်ရန်',
  ResumePhoto: 'ကိုယ်ရေးရာဇဝင်ဓာတ်ပုံ',
  BasicInfo: 'အခြေခံအချက်အလက်',
  'Full Name': 'နာမည်အပြည့်အစုံ',
  'Job Role': 'အလုပ်အကိုင်',
  Email: 'အီးမေးလ်',
  'Phone Number': 'ဖုန်းနံပါတ်',
  Address: 'လိပ်စာ',
  Summary: 'အကျဉ်းချုပ်',
  Education: 'ပညာရေးနောက်ခံ',
  Institution: 'ကျောင်း/တက္ကသိုလ်',
  Degree: 'ဘွဲ့/လက်မှတ်',
  'Start Date (YYYY-MM-DD)': 'စတင်သည့်ရက်စွဲ (YYYY-MM-DD)',
  'End Date (YYYY-MM-DD)': 'ပြီးဆုံးသည့်ရက်စွဲ (YYYY-MM-DD)',
  'Currently Studying Here': 'လက်ရှိတက်ရောက်နေဆဲ',
  'Short Description': 'အကျဉ်းချုပ်ဖော်ပြချက်',
  Achievements: 'အောင်မြင်မှုများ',
  'Achievement text': 'အောင်မြင်မှုအသေးစိတ်',
  Employment: 'လုပ်ငန်းအတွေ့အကြုံ',
  'Job Title': 'ရာထူး',
  Company: 'ကုမ္ပဏီ',
  'Currently Working Here': 'လက်ရှိလုပ်ကိုင်နေဆဲ',
  Responsibilities: 'တာဝန်ဝတ္တရားများ',
  'Responsibility text': 'တာဝန်အသေးစိတ်',
  Skills: 'ကျွမ်းကျင်မှုများ',
  'Skill Name': 'ကျွမ်းကျင်မှုအမည်',
  Add: 'ထည့်ပါ',
  'Add Education': 'ပညာရေးနောက်ခံ ထည့်ရန်',
  'Add Employment': 'လုပ်ငန်းအတွေ့အကြုံ ထည့်ရန်',
  'Add Skill': 'ကျွမ်းကျင်မှုများ ထည့်ရန်',
  'ai_image': 'AI ပုံ',
};



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js